import { render, staticRenderFns } from "./AssetsModal.vue?vue&type=template&id=6a7e4add&scoped=true&"
import script from "./AssetsModal.vue?vue&type=script&lang=ts&"
export * from "./AssetsModal.vue?vue&type=script&lang=ts&"
import style0 from "./AssetsModal.vue?vue&type=style&index=0&id=6a7e4add&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7e4add",
  null
  
)

export default component.exports